import { graphql } from '../gql';

export const confirmSiteDirectionsToken = graphql(`
  mutation ConfirmSiteDirectionsToken($digest: String!) {
    confirmSiteDirectionsToken(input: { digest: $digest }) {
      siteDirectionsToken {
        id
        state
        confirmed
        digest
      }
      error {
        code
        message
      }
    }
  }
`);
